import lang from "element-ui/lib/locale/lang/zh-CN";
export default {
  ...lang,
  failed: "操作失败",
  success: "操作成功",
  暂未开通功能: "功能正在调试中，期待早日上线",
  "功能正在研发中...": "功能正在调试中，期待早日上线",
  服务: "服务",
  服务介绍: "服务介绍",
  国际运输: "国际运输",
  首页: "首页",
  合作意向: "合作意向",
  VIEW: "查询",
  "Expand More": "查看更多",
  关于我们: "关于我们",
  帮助中心: "帮助中心",
  公司简介: "公司简介",
  加入我们: "加入我们",
  "contact us": "联系我们",
  "12 Countries’ Official Websites": "8国官网",
  "J&T Express exclusive APP": "J&T EXPRESS APP",
  "J&T Express exclusive APP One-click order, real-time query, worry-free delivery, express surprise":
    "J&T Express 专属APP，一键下单，实时查询，寄递无忧，速递惊喜。",
  CHINA: "中国大陆",
  SINGAPORE: "新加坡",
  CAMBODIA: "柬埔寨",
  THAILAND: "泰国",
  PHILIPPINES: "菲律宾",
  MALAYSIA: "马来西亚",
  VIETNAM: "越南",
  INDONESIA: "印度尼西亚",
  ARABIA: "沙特阿拉伯王国",
  UAE: "阿联酋",
  EGYPT: "埃及",
  MEXICO: "墨西哥",
  BRAZIL: "巴西",
  "999开头的及J开头的单号查询": "目前仅提供999开头的及J开头的单号查询",
  pageIndex: {
    searchPlaceholder: "请输入您的运单号，实时追踪您的运单状态",
    onlineMail: "在线寄件",
    Inquires: "一键查询",
    ShippingRates: "Manda fácil",
    TransitTime: "快递时效",
    ServicePoints: "服务网点",
    ServiceCoverage: "收寄范围",
    Address: "***,***,***,******",
    phone: "***-****-****",
    email: "meajuda@jtexpress.com.br",
    税号: "CPF/CNPJ",
    税号不能为空: "CPF/CNPJ不能为空",
    "CPF/CNPJ为11~14位数字": "CPF/CNPJ为11~14位数字",
    "对不起，没有找到该订单的信息": "对不起，没有找到该订单的信息",
    请确认订单号是正确的: ". 请确认订单号是正确的。",
  },
  pageOnlineOrder: {
    请完善地址信息: "请完善地址信息",
    我们将上门取件: "我们将上门取件",
    寄件人信息: "寄件人信息",
    从通讯录选择: "从地址簿选择",
    清空: "清空",
    添加到通讯录: "添加到通讯录",
    省市区: "省市区",
    详细地址: "详细地址",
    收件人信息: "收件人信息",
    物品信息: "物品信息",
    物品类型: "物品类型",
    物品名称: "物品名称",
    结算方式: "结算方式",
    物品重量: "物品重量",
    备注: "备注",
    下单: "下单",
    寄件地址与收件地址不能相同: "寄件地址与收件地址不能相同",
    "预估费用(不含税)": "预估费用(不含税)",
    "预估费用(含税)": "预估费用",
    预估费用: "预估费用",
    最终运费以收派员为准: "最终运费以收派员为准",
    立即下单: "立即下单",
    下单成功: "下单成功",
    业务员正在快马加鞭赶过来: "业务员正在快马加鞭赶过来，请保持电话畅通",
    订单号: "订单号",
    复制: "复制",
    关闭: "关闭",
    查看订单: "查看订单",
    产品类型: "产品类型",
    请选择产品类型: "请选择产品类型",
    姓名: "姓名",
    手机号: "手机号",
    请输入手机号: "请输入手机号",
    手机号码: "手机号码",
    请输入姓名: "请输入姓名",
    请输入详细地址: "请输入详细地址",
    请选择物品类型: "请选择物品类型",
    请输入物品名称: "请输入物品名称",
    请选择付款方式: "请选择付款方式",
    请输入物品重量: "请输入物品重量",
    请输入备注: "请输入备注",
    寄付现结: "寄付现结",
    到付现结: "到付现结",
    点击填写寄件人信息: "点击填写寄件人信息",
    点击填写收件人信息: "点击填写收件人信息",
    邮箱: "邮箱",
    省份: "省份",
    州: "州",
    请选择省份: "请选择省份",
    请选择州: "请选择州",
    城市: "城市",
    市: "市",
    请选择城市: "请选择城市",
    乡镇: "乡镇",
    请选择乡镇: "请选择乡镇",
    街道: "街道",
    支付方式: "支付方式",
    "体积(CM)": "体积(CM)",
    体积: "体积(CM)",
    信息查询: "信息查询",
    运单号不能为空: "运单号不能为空",
    查询: "查询",
    寄件地址簿: "寄件地址簿",
    收件地址簿: "收件地址簿",
    手机: "手机",
    地址: "地址",
    联系人: "联系人",
    选择联系人: "选择联系人",
    现金: "现金",
    长: "长",
    宽: "宽",
    高: "高",
    "以上运费不含燃油附加费和增值税，具体标准以当地门店的标准为准": "以上运费不含燃油附加费和增值税，具体标准以当地门店的标准为准",
    未查询到运费金额: "未查询到运费金额，请联系客服",
    保存: "保存",
    预估运费: "预估运费",
    单边长度不超过158cm: "单边长度不超过158cm",
    长宽高三边长度之和不超274cm: "长宽高三边长度之和不超274cm",
    "勾选体积时，长宽高皆不可为空": "勾选体积时，长宽高皆不可为空",
    "0＜重量≤30KG，1位小数": "0＜重量≤30KG，1位小数",
    长度不超过20个字符: "长度不超过20个字符",
    长度不超过30个字符: "长度不超过30个字符",
    长度不超过50个字符: "长度不超过50个字符",
    长度不超过200个字符: "长度不超过200个字符",
    请输入正确的邮箱: "请输入正确的邮箱",
    请输入正确的手机号: "请输入正确的手机号",
    请选择支付方式: "请选择支付方式",
    请选择结算方式: "请选择结算方式",
    确认修改: "确认修改",
    公司名称: "公司名称",
    请输入公司名称: "请输入公司名称",
    详细地址1: "详细地址1",
    详细地址2: "详细地址2",
    "净重(kg)": "净重(kg)",
    "包裹重(kg)": "包裹重(kg)",
    请输入净重: "请输入净重",
    "0＜重量≤30KG，2位小数": "0＜重量≤30KG，2位小数",
    邮编: "邮编",
    请输入邮编: "请输入邮编",
    请输入邮编获取: "请输入邮编获取",
    优惠券信息: "优惠券信息",
    结算方式说明: "PP_CASH：寄付现结；<br>CC_CASH：到付现结；<br>PP_PM：寄付月结",
  },
  networkSelect: {
    请输入邮编: "请输入邮编",
    服务网点: "服务网点",
    查询: "查询",
    暂无数据: "暂无数据",
    导航: "导航",
    快递时效: "快递时效",
    运单费用: "运单费用",
    网点查询: "网点查询",
    收寄范围: "收寄范围",
    收件网点: "收件网点",
    派件网点: "派件网点",
    总条数Msg: "查询到{}个网点",
    "州/市": "州/市",
    "网点正在努力开发中！": "网点正在努力开发中！",
    请输入有效邮编: "请输入有效邮编",
    "您检索的邮编可能有误，验证后重试。": "您检索的邮编可能有误，验证后重试。",
  },
  pagePublicServe: {
    info: "J&T Express 对全国0-30KG的电商快件提供门到门的标准快递服务，为电商客户提供一体化的物流解决方案。",
    expressDeliveryService: "J&T Express 为客户提供7×24小时，365天全年无休的快件收寄服务，随时随地满足客户的寄递需求。",
    "365DaysService": "全年无休",
    "24HOURS": "7×24 小时",
    FastResponse: "对于客户提出的需求，J&T Express 竭尽所能快速反馈解决方案。",
    PersonalizedServices:
      "对于有着更高安全保障需求和时效需求的VIP客户，J&T Express 将提供定制化、个性化的专属VIP服务解决方案，免除客户的一切后顾之忧。",
    VipService: "VIP服务",
    personalized: "个性化",
    customized: "定制化",
    TraceTrack: "客户可以通过J&T Express 官网和手机APP实时查询运单的轨迹，了解运单状态。",
    "E-commercePartners": "J&T Express 已经与国内主流电商平台达成业务合作，向电商客户提供安全可靠的物流服务。",
  },
  "365 DAYS OF OPERATION": "全年无休",
  "FAST RESPONSE": "极速响应",
  "PERSONALIZED SERVICES": "个性化服务",
  "TRACE & TRACK": "实时查询",
  "E-commerce Partners": "合作电商平台",
  "About Us": "关于我们",
  "Who Are We": "我们是谁",
  "WHO ARE WE": "我们是谁",
  "Business Culture": "企业文化",
  "BUSINESS CULTURE": "企业文化",
  "Brand Strength": "品牌实力",
  "BRAND STRENGTH": "品牌实力",
  "Brand History": "品牌历史",
  "BRAND HISTORY": "品牌历史",
  Mission: "使命",
  Vision: "愿景",
  "Core Values": "价值观",
  pageAboutUs: {
    WhoAreWe:
      "J&T Express 是一家面向全球的科技创新型综合物流服务商。我们致力于持续为客户创造极致的快递和物流体验，成为一家值得客户信赖的综合性物流服务商。",
    Mission: "客户为本，效率为根",
    Vision: "成为健康、长久的企业",
    Core: "本分、分享、责任",
    BrandStrength_one:
      "J&T Express 涉及快递、快运、仓储及供应链等多元化领域，业务类型涵盖同城、跨省及国际件。J&T Express 的快递服务网络覆盖13个国家，触达全球近25亿人口。",
    BrandStrength: "240+大型转运中心，1000+智能分拣设备，10000+自有车辆，23000+网点，400000+服务人员。",
    BrandHistory:
      "J&T Express 创立于2015年，目前我们的服务网络已经覆盖全球13个国家，每天为客户提供优质高效和稳定可靠的快递物流服务，让全球更多的消费者享受到电商经济时代的便利。",
  },
  pageTrajectoryQuery: {
    单号列表: "单号列表",
    运单信息: "运单信息",
    无效运单号: "无效运单号",
    运单号Msg: "抱歉，未查到此运单{}信息，请确认运单号号码是否正确",
    存在非法运单号: "存在非法运单号",
    查询: "查询",
    运单列表: "运单列表",
    运单详情: "运单详情",
    快件跟踪: "快件跟踪",
    运单号不能为空: "运单号不能为空",
    运单号: "运单号",
    街道: "街道",
    只支持查询1条运单号: "只支持查询1条运单号",
    单次最多查询10条运单号: "单次最多查询10条运单号",
    searchPlaceholder2: "输入运单号进行查询，请以逗号，分号键隔开，单次最大查询10条",
    安全提醒: "安全警示：J&T快递不会通过WhatsApp/短信/第三方链接要求您支付包裹清关费用。任何费用支付或配送更新，请仅使用J&T官方渠道处理。",
    收件人信息确认: "收件人信息确认",
    "收件人CNPJ/CPF": "收件人CNPJ/CPF",
    收件人CEP: "收件人CEP",
    校验: "校验",
    "请输入收寄件人CPF/CNPJ": "请输入收寄件人CPF/CNPJ",
  },
  "June 2021": "2021年6月",
  "J&T Express USE, Saudi Arabia, Brazil, Mexico, Egypt officially launched": "J&T Express 阿联酋、沙特阿拉伯、巴西、墨西哥、埃及正在筹备中",
  "March 2020": "2020年3月",
  "J&T Express China officially established": "J&T Express 中国正式营业",
  "January 2020": "2020年1月",
  "J&T Express Singapore officially established": "J&T Express 新加坡正式营业",
  "October 2019": "2019年10月",
  "J&T Express Cambodia officially established": "J&T Express 柬埔寨正式营业",
  "March 2019": "2019年3月",
  "J&T Express Thailand was officially established": "J&T Express 泰国正式营业",
  "J&T Express Philippines officially established": "J&T Express 菲律宾正式营业",
  "August 2018": "2018年8月",
  "J&T Express Malaysia officially established": "J&T Express 马来西亚正式营业",
  "July 2018": "2018年7月",
  "J&T Express Vietnam officially established": "J&T Express 越南正式营业",
  "October 2017": "2017年10月",
  October2017History: '"Express Your Online Business" 战略发布会召开，标志J&T集团进入电商快递时代',
  "August 2015": "2015年8月",
  "J&T Express Indonesia officially established": "J&T Express 印尼正式营业",
  "BE TOGETHER BETTER FUTURE": "在一起，有未来",
  "JOIN US": "加入我们",
  joinUsInfo:
    "人才是J&T Express 最宝贵的财富。J&T Express 倡导以本分为核心的价值观，培育出“在一起、有未来”的文化氛围，鼓励内部分享，始终坚持为员工提供一个平等、多元和包容融合发展的工作环境，对于不同性别、国籍、民族和宗教信仰的员工给予充分尊重。通过完善的培训体系和独有的合伙人制度，J&T Express 为员工提供了一个通向未来的职业发展路径。",
  "EXPLORE POSITIONS": "探索职务",
  "More great jobs coming soon…": "更多好工作即将发布……",
  "RECRUITMENT E-MAIL": "招聘邮箱",
  信息: "信息",
  隐私政策: "隐私政策",
  关注我们: "关注我们",
  其他市场官网: "其他市场官网",
  "关于 J&T EXPRESS": "关于 J&T EXPRESS",
  中国大陆: "中国大陆",
  中国香港: "中国香港",
  印度尼西亚: "印度尼西亚",
  马来西亚: "马来西亚",
  菲律宾: "菲律宾",
  新加坡: "新加坡",
  柬埔寨: "柬埔寨",
  泰国: "泰国",
  越南: "越南",
  沙特阿拉伯: "沙特阿拉伯",
  阿拉伯联合酋长国: "阿拉伯联合酋长国",
  墨西哥: "墨西哥",
  埃及: "埃及",
  "营业时间 ": "营业时间 ",
  "上午8:00 - 晚上6:00": "上午8:00 - 晚上6:00",
  "周一至周四  —— 08h - 18h": "周一至周四  —— 08h - 18h",
  "周五至周六  —— 08h - 17h": "周五至周六  —— 08h - 17h",
  预计签收时间: "预计签收时间",
  查看图片: "查看图片",
  预览图片: "预览图片",
  网点类型: "网点类型",
  收件网点: "收件网点",
  派件网点: "派件网点",
  "在这里模拟您的配送，找到运往巴西各地的最佳运费": "在这里模拟您的配送，找到运往巴西各地的最佳运费！",
  始发地邮编: "始发地邮编",
  目的地邮编: "目的地邮编",
  高: "高",
  宽: "宽",
  长: "长",
  重量: "重量",
  货物价值: "货物价值",
  计算运费: "计算运费",
  清空: "清空",
  寄件网点: "寄件网点",
  "仅供参考，根据实际情况可能会有变动": "仅供参考，根据实际情况可能会有变动",
  最大30公斤: "最大30公斤",
  无效邮编: "无效邮编",
  含税金额: "含税金额",

  登录: "登录",
  注册: "注册",
  退出登录: "退出登录",
  输入您的电子邮件或电话号码: "输入您的电子邮件或电话号码",
  请输入密码: "请输入密码",
  立即注册: "立即注册",
  忘记密码: "忘记密码",
  登录成功: "登录成功",
  姓名: "姓名",
  电话: "电话",
  验证码已通过电子邮件发送: "验证码已通过电子邮件发送",
  验证码: "验证码",
  获取验证码: "获取验证码",
  密码: "密码",
  确认密码: "确认密码",
  确认: "确认",
  "已有账号，去登录": "已有账号，去登录",
  我已阅读并接受: "我已阅读并接受",
  使用条款: "使用条款",
  隐私协议: "隐私协议",
  "密码格式为6~16位大小写字母加数字": "密码格式为6~16位大小写字母加数字",
  密码不一致: "密码不一致",
  邮箱格式不正确: "邮箱格式不正确",
  请输入姓名: "请输入姓名",
  请输入电话号码: "请输入电话号码",
  请输入CPF或CNPJ: "请输入CPF或CNPJ",
  CPF或CNPJ: "CPF或CNPJ",
  请输入验证码: "请输入验证码",
  长度在8到14位: "长度在8到14位",
  注册成功: "注册成功",
  找回密码: "找回密码",
  请输入您的邮箱: "请输入您的邮箱",
  再次输入密码: "再次输入密码",
  密码修改成功: "密码修改成功",
  手机号: "手机号",
  邮箱: "邮箱",
  请输入邮箱: "请输入邮箱",
  和: "和",
  我要寄件: "我要寄件",
  运费查询: "运费查询",
  轨迹查询: "轨迹查询",
  我的订单: "我的订单",
  联系客服: "联系客服",
  我的数据: "我的数据",
  清除数据: "清除数据",
  "%天送达": "%天送达",
  预测: "预测",
  将于以下日期到达: "将于以下日期到达",
  发送: "发送",
  返回: "返回",
  欢迎: "欢迎",
  下单日期: "下单日期",
  订单号: "订单号",
  运单号: "运单号",
  运费: "运费",
  订单状态: "订单状态",
  面单: "面单",
  点击下载: "点击下载",
  下载中: "下载中",
  物品金额: "物品金额",
  立即下单: "立即下单",
  物品信息: "物品信息",
  物品名称: "物品名称",
  请输入物品名称: "请输入物品名称",
  本人声明此处描述的所有内容均属真实: "本人声明此处描述的所有内容均属真实",
  寄件人: "寄件人",
  "请输入CNPJ/CPF": "请输入CNPJ/CPF",
  寄件人姓名: "寄件人姓名",
  请输入寄件人姓名: "请输入寄件人姓名",
  请输入手机号: "请输入手机号",
  请输入电话: "请输入电话",
  邮编: "邮编",
  请输入邮编: "请输入邮编",
  详细地址: "详细地址",
  请输入详细地址: "请输入详细地址",
  街道号: "街道号",
  请输入街道号: "请输入街道号",
  街道: "街道",
  请输入街道: "请输入街道",
  区: "区",
  省: "省",
  市: "市",
  请输入IE: "请输入IE",
  选择取件网点: "选择取件网点",
  取件网点名称: "取件网点名称",
  收件人: "收件人",
  确定: "确定",
  请输入高: "请输入高",
  请输入宽: "请输入宽",
  请输入长: "请输入长",
  请输入重量: "请输入重量",
  请输入货物价值: "请输入货物价值",
  请输入邮编获取省市区: "请输入邮编获取省市区",
  "长度为11-14位": "长度为11-14位",
  "长度为8-14位": "长度为8-14位",
  长度为8位: "长度为8位",
  "长度为2-200位": "长度为2-200位",
  请选择取件网点: "请选择取件网点",
  订单已确认: "订单已确认",
  "您的面单将通过电子邮件发送，附带邮寄指南。": "您的面单将通过电子邮件发送，附带邮寄指南。",
  订单详情: "订单详情",
  继续下单: "继续下单",
  在搜索栏中输入邮编查询: "在搜索栏中输入邮编查询",
  搜索: "搜索",
  距离: "距离",
  选择: "选择",
  收件人姓名: "收件人姓名",
  请输入收件人姓名: "请输入收件人姓名",
  电话号码格式不正确: "电话号码格式不正确",
  轨迹跟踪: "轨迹跟踪",
  查看全部: "查看全部",
  详情: "详情",
  ies: {
    国际运输服务: "国际运输服务",
    提供全程追踪服务: "提供全程追踪服务，",
    智能且高性价比的国际运输解决方案: "智能且高性价比的国际运输解决方案！",
    简介: '我们致力于简化跨境货物运往巴西的流程，提供高效且具成本优势的解决方案，让您无须再为复杂的手续和时效问题烦恼。无论是"门到门"的一站式物流服务，还是量身定制的分步方案，我们的灵活服务都能满足您的需求，确保运输全程轻松无忧',
    为什么: "为什么选择J&T Express作为您的国际运输服务商？",
    便捷: "便捷：",
    便捷说明: "我们为您提供便捷服务，全链路细节处理，减少复杂程序。",
    经济: "经济：",
    经济说明: "我们为您提供提高时效与优化成本的智能且经济的解决方案。",
    可靠: "可靠：",
    可靠说明: "凭借我们丰富的行业经验，确保您的货物顺利抵达目的地。",
    我们为您的业务提供多种解决方案: "我们为您的业务提供多种解决方案",
    我们的专业领域: "我们的专业领域:",
    了解更多: "了解更多",
    电子商务: "电子商务",
    电子商务说明开头: "依靠我们的专业经验，",
    电子商务说明:
      "为您的电子商务提供商品的派送与揽收服务。我们将通过我们在全球范围内的自有网络和合作伙伴为您提供全程服务。我们会从订单揽收到发货、清关，照顾每一个环节。这意味着您可以将繁琐的手续交给我们，腾出更多时间专注于销售和业务增长。我们简化物流程序，让您在电子商务领域迈向新的成功高峰。",
    国际货物运输: "国际<br/>货物运输",
    国际货物运输说明开头: "在J&T Express，",
    国际货物运输说明:
      "我们致力于让您进口商品的过程更简单高效。我们的国际货物运输服务专为满足您的进口需求而设计，特别关注快递服务，确保快速、可靠、合规、透明、可追踪，帮助您节省时间和成本。",
    货物合规运输计划: "货物合规运输计划<br/>（PRC）",
    货物合规运输计划1: "货物合规运输计划（PRC）",
    货物合规运输计划说明开头: "通过获得联邦税务局的货物合规运输计划（PRC）认证，",
    货物合规运输计划说明:
      "电子商务企业可以享受税收与海关方面的优惠，适用于通过国际运输发送到巴西的商品，享有简化征税制度下的折扣。对于价值不超过50美元（或其他货币等值）的个人快递，适用零进口税率，同时此类快递在清关时享有优先处理权。 ",
    更多: "想了解更多详细信息，",
    请访问: "请访问：",
    客服: "如果您还有其他问题，请联系J&T Express客服中心，我们乐意为您提供帮助。",
    样品寄送: "样品寄送",
    样品寄送说明开头: "如果您需要从海外客户或合作伙伴处寄送或接收样品，",
    样品寄送说明:
      "我们可以帮助您简化这一过程，且成本低廉。我们提供无商业价值的国际样品寄送服务，确保您的样品快速安全地抵达目的地，并符合所有海关规定。",
    规则: "规则",
    规则说明:
      "规则：<br>- 简化流程，无需RADAR或报关代理。<br/>- 商品价值不得超过3,000.00美元，或其他货币等值。<br/>- 企业无论是否有商业目的均可寄送（适用于年销售额不超过150,000.00美元的商品）。<br/>- 个人不得以商业目的寄送商品（不允许以数量和频率构成商业行为的方式进行寄送）。<br/>- 必须提前由承运人提供信息（CPF、姓名、地址等），否则将无法完成清关，货物将被退回，产生费用由发货方承担。详见2022年12月16日第2124号联邦税务局指令。<br/>- 每个包裹的重量限制为30公斤。<br/>- 非侵入性检查的尺寸限制为90厘米 x 100厘米。<br/>- 必须附有商业发票。<br/>- 根据2003年12月29日第10833号法第70条的规定，妥善保管与进口/出口相关的文件。<br/>- 如有未解决事项，文件保管期限为货物到达后20天内，若未能解决将被退回。",
    征税制度: "征税制度",
    征税制度说明:
      "征税制度<br/>简化征税制度对所有进口商品统一征收60%的进口税（II），不考虑关税分类，外加目的地所在州的ICMS税，适用于CIF价值加上进口税的总额。免征IPI、PIS和COFINS税。<br/><br/>货物合规运输计划<br/>进口税率仅适用于符合以下条件的国际快递：<br/>- 由在货物合规运输计划认证下的电子商务公司提供。<br/>- 价值不超过50美元（或等值货币）的商品，适用20%的进口税。<br/>- 价值超过50.01美元（或等值货币）的商品，适用60%的进口税，并享有20美元的税收减免。<br/>- 仅限个人消费者。<br/>- 需提前支付17%的ICMS税。<br/>对于不符合上述所有要求的国际包裹，简化征税制度的税率仍为60%（加上目的地所在州的ICMS税）。<br/><br/>个人药品进口<br/>个人进口成品药品的金额限额为10,000.00美元（美金一万），必须符合1999年6月24日第156号令和第7条的要求。<br/>如申报的海关总价值超过法定限制，进口仅在包裹中包含成品药物时允许（根据2024年7月31日第2208号指令的修订）。<br/>这些药品的放行需遵守国家卫生监督局（ANVISA）设定的要求。<br/><br/>请注意，该优惠仅适用于个人用药，且仅限于个人使用（如父母为子女进口药物）。该优惠不适用于兽用药物、补充剂和化妆品的进口。<br/><br/>无陪同行李<br/>应申请，国际快递中的货物可视为无陪同行李，前提是这些货物来自于旅行者曾经逗留或居住的国家。<br/>无陪同行李的定义为：在旅行者逗留地或来源地寄出的国际包裹，并在旅行者抵达之前的3个月或抵达后的6个月内送达。<br/><br/>以下情况将免征关税：<br/>- 国内或国有物品的回归；<br/>- 使用过的个人衣物及物品，以及书籍、宣传册和期刊；<br/>- 根据2010年IN RFB第1.059号规定，来自国外的居民在永久居留时携带的新旧物品，或在国外居住超过1年的巴西公民的回国物品。 <br/><br/>无商业价值样品<br/>要享受这一免税政策，物品必须符合无商业价值样品的定义，即任何在此条件下进口的物品，旨在展示其特性，完全不具备商业价值，无论是因为没有价值、数量、重量、体积或其他展示条件，或因物理操作而被剥夺了商业价值，确保无法销售。<br/><br/>书籍、报纸和期刊<br/>对书籍、报纸和期刊的进口以及用于印刷的纸张，适用进口税免征政策。<br/>为获得免征,物品必须符合2003年第10.753号法第2条中对书籍的定义",
    法律法规: "法律法规",
    法律法规说明:
      "相关法规包括：<br/>-财政部第156号命令，1999年6月24日<br/>-2017年9月15日第1737号规范性指令<br/>-COANA第81号命令，2017年10月17日<br/>-财政部第612号命令，2023年6月29日<br/>-RFB第2146号规范性指令，2023年6月29日<br/>-COANA第130号命令，2023年7月25日",
    违禁物品: "违禁物品",
    违禁物品说明:
      "需要LI（进口许可证）的物品：<br/>- 酒精饮料<br/>- 香烟、雪茄及烟草制品<br/>- 货币（现金）<br/>- 野生动物及植物<br/>- 使用过的或翻新的物品（个人使用的除外）<br/>- 枪支及弹药<br/>- 古董及艺术品<br/>- 伪造产品<br/>- 易燃或危险材料<br/>- 钻石、贵重宝石及珠宝<br/>- 毒品（非法药物）<br/>- 化学材料<br/>- 游戏材料<br/>- 人体部位，包括骨灰<br/>- 其他运输受国际民航法禁止的物品",
  },
  请输入物品类型: "请输入物品类型",
  禁止运输货物清单: "禁止运输货物清单",
  运输限制: "运输限制",
  "重量: 最大允许为30kg": "重量: 最大允许为30kg",
  "高度: 允许包裹高度在1到120cm之间": "高度: 允许包裹高度在1到120cm之间",
  "宽度: 允许包裹宽度在1到120cm之间": "宽度: 允许包裹宽度在1到120cm之间",
  "长度: 允许包裹长度在1到120cm之间": "长度: 允许包裹长度在1到120cm之间",
  三边之和不得超过240厘米: "三边之和不得超过240厘米",
  生物材料样本: "生物材料样本",
  已死亡动物: "已死亡动物",
  武器和军事装备: "武器和军事装备",
  "香烟、烟草制品及类似产品": "香烟、烟草制品及类似产品",
  腐蚀性物质: "腐蚀性物质",
  活生物: "活生物",
  现金: "现金",
  法律禁止的毒品: "法律禁止的毒品",
  爆炸物: "爆炸物",
  珠宝和贵重石: "珠宝和贵重石",
  液体: "液体",
  放射性物质: "放射性物质",
  药物: "药物",
  危害国家安全的物品: "危害国家安全的物品",
  鸟蛋: "鸟蛋",
  种子: "种子",
  活植物: "活植物",
  各类危险品: "各类危险品",
  尸体: "尸体",
  对邮政服务的风险: "对邮政服务的风险",
  气雾剂: "气雾剂",
  易燃固体: "易燃固体",
  "易腐烂、易变质、有异味、令人作呕和有害的物质": "易腐烂、易变质、有异味、令人作呕和有害的物质",
  锂离子电池和电池: "锂离子电池和电池",
  "压缩气体、液化气体或溶解在压力下的气体": "压缩气体、液化气体或溶解在压力下的气体",
  艺术品: "艺术品",
  氧化剂和有机过氧化物: "氧化剂和有机过氧化物",
  有毒物质和感染性物质: "有毒物质和感染性物质",
  请输入: "请输入",
  下载: "下载",
  "未获取到CT-E信息": "未获取到CT-E信息",
  请输入CPF: "请输入CPF",
  长度为11位: "长度为11位",
  请输入CNPJ: "请输入CNPJ",
  长度为14位: "长度为14位",
  "CT-E 下载": "CT-E 下载",
  输入的CPF不正确: "输入的CPF不正确",
  输入的CNPJ不正确: "输入的CNPJ不正确",
  全名: "全名",
  电子邮箱: "电子邮箱",
  收货地址: "收货地址",
  产品类型: "产品类型",
  每月平均订单数量: "每月平均订单数量",
  网站链接: "网站链接",
  备注: "备注",
  请选择省市区: "请选择省市区",
  "我们为整个巴西提供配送服务，立刻送达！": "我们为整个巴西提供配送服务，立刻送达！",
  "想让 J&T 成为您电商的配送合作伙伴吗？ 请填写下面的表格，我们将尽快与您联系！":
    "想让 J&T 成为您电商的配送合作伙伴吗？ 请填写下面的表格，我们将尽快与您联系！",
  "我们已经收到您的信息填报，将尽快与您取得联系！": "我们已经收到您的信息填报，将尽快与您取得联系！",
  "登录之后才能操作！": "登录之后才能操作！",
  限制100字符以内: "限制100字符以内",
  "0-99999999之间的数字": "0-99999999之间的数字",
  限制30字符以内: "限制30字符以内",
  限制200字符以内: "限制200字符以内",
  限制500字符以内: "限制500字符以内",
  "我想通过 WhatsApp 接收有关我的订单的最新信息": "我想通过 WhatsApp 接收有关我的订单的最新信息",
  我同意接收实时讯息和促销活动: "我同意接收实时讯息和促销活动",
  修改密码: "修改密码",
  最喜欢的网点: "最喜欢的网点",
  请输入旧密码: "请输入旧密码",
  请输入新密码: "请输入新密码",
  "密码必须包含大小写字母，数字及特殊字母其中三种，位数限制8-20位": "密码必须包含大小写字母，数字及特殊字母其中三种，位数限制8-20位",
  确认更改: "确认更改",
  "修改成功，请重新登录": "修改成功，请重新登录",
  网点更新成功: "更新成功",
  选择最喜欢的网点: "选择最喜欢的网点",
  地址管理: "地址管理",
  新增: "新增",
  删除: "删除",
  编辑: "编辑",
  查询姓名: "查询姓名",
  "查询CPF/CNPJ": "查询CPF/CNPJ",
  新增地址簿: "新增地址簿",
  保存: "保存",
  取消: "取消",
  编辑地址簿: "编辑地址簿",
  未查询到数据: "未查询到数据",
  "请输入CPF/CNPJ": "请输入CPF/CNPJ",
  请输入电子邮箱: "请输入电子邮箱",
  请输入邮政编码: "请输入邮政编码",
  "请输入州/市/区": "请输入州/市/区",
  "查询到相关地址信息，确认是否自动补充": "查询到相关地址信息，确认是否自动补充",
  温馨提示: "温馨提示",
  是: "是",
  否: "否",
  请确认是否删除: "请确认是否删除",
  保留: "保留",
  "州/市/区": "州/市/区",
  邮政编码: "邮政编码",
  请求成功: "请求成功",
  保存到地址簿: "保存到地址簿",
  CPF或CNPJ已存在: "CPF或CNPJ已存在",
  长宽高总和不可超过240CM: "长宽高总和不可超过240CM",
  输入需大于1: "输入需大于1",
  公司名称: "公司名称",
  查件: "查件",
  客户: "客户",
  服务支持: "服务支持",
  B2C服务: "B2C服务",
  C2C服务: "C2C服务",
  CBT服务: "CBT服务",
  联系我们: "联系我们",
  客户案例: "客户案例",
  客户专享: "客户专享",
  企业文化: "企业文化",
  发展历史: "发展历史",
  订单反馈: "订单反馈",
  环保反馈: "环保反馈",
  成为司机: "成为司机",
  招聘信息: "招聘信息",
  服务网点: "服务网点",
  输入您的电子邮件或手机号: "输入您的电子邮件或手机号",
  寄件单号列表: "寄件单号列表",
  收件单号列表: "收件单号列表",
  "如果需要查询详细轨迹，请输入CPF/CNPJ": "如果需要查询详细轨迹，请输入CPF/CNPJ",
  请对您遇到的问题进行描述: "请对您遇到的问题进行描述",
  请输入反馈信息: "请输入反馈信息",
  "请输入运单号、发票密钥或客户订单号，使用逗号或分号分隔，最多可输入30个，且不支持混合查询":
    "请输入运单号、发票密钥或客户订单号，使用逗号或分号分隔，最多可输入30个，且不支持混合查询",
  "对不起，没有查询到相关轨迹，请核实": "对不起，没有查询到相关轨迹，请核实。",
  "此为巴西本地数据，截止日期为01/12/2024": "此为巴西本地数据，截止日期为01/12/2024",
  "相关信息，将通过邮件发送给您。": "相关信息，将通过邮件发送给您。",
  下载集成手册: "下载集成手册",
  使用物品申明创建订单: "使用物品申明创建订单",
  点击下载表格模版: "点击下载表格模版",
  点击上传表格: "点击上传表格",
  使用发票创建订单: "使用发票创建订单",
  批量选择XML发票文件: "批量选择XML发票文件",
  每次最多可上传30条数据: "每次最多可上传30条数据",
  文件解析失败: "文件解析失败",
  文件解析成功: "文件解析成功",
  查看详情: "查看详情",
  批量导入: "批量导入",
  XML文件解析失败: "XML文件解析失败",
  客户订单编号: "客户订单编号",
  操作: "操作",
  上传: "上传",
  上传成功: "上传成功",
  上传失败: "上传失败",
  状态: "状态",
  选择网点: "选择网点",
  网点名称: "网点名称",
  "仅勾选的订单会被下单，未勾选的订单将被移除，请确认。": "仅勾选的订单会被下单，未勾选的订单将被移除，请确认。",
  重新上传: "重新上传",
  下单: "下单",
  暂无数据: "暂无数据",
  "文件上传中...": "文件上传中...已选择{count}个文件",
  请选择订单: "请选择订单",
  成为VIP: "成为VIP",
  "更快、更高效的运输": "更快、更高效的运输",
  节省时间并赢得客户: "节省时间并赢得客户",
  完全自主: "完全自主",
  "轻松、无复杂性地管理您的订单": "轻松、无复杂性地管理您的订单",
  智能控制: "智能控制",
  "查看您的销售情况、跟踪发货并优化您的结果": "查看您的销售情况、跟踪发货并优化您的结果",
  什么是VIP: "什么是VIP",
  "VIP系统是一款专为中小型企业主开发的平台，专注于简化订单与销售管理。 它提供以下功能：":
    "VIP系统是一款专为中小型企业主开发的平台，专注于简化订单与销售管理。 它提供以下功能：",
  高效管理: "高效管理",
  一站式全面掌控所有订单: "一站式全面掌控所有订单",
  快速定制化发货: "快速定制化发货",
  "优化流程，精准满足客户需求": "优化流程，精准满足客户需求",
  自主管理权限: "自主管理权限",
  "简洁实用的工具，全程跟踪从下单到交付的每个环节": "简洁实用的工具，全程跟踪从下单到交付的每个环节",
  数据报告与分析: "数据报告与分析",
  "直观查看业务表现，助力战略决策": "直观查看业务表现，助力战略决策",
  VIP提供哪些服务: "VIP提供哪些服务",
  存储数据: "存储数据",
  系统注册: "系统注册",
  系统: "系统",
  管理已发送的订单: "管理已发送的订单",
  运输类型: "运输类型",
  权限分配: "权限分配",
  运费报价: "运费报价",
  "立即联系我们，迈出成功的下一步！": "立即联系我们，迈出成功的下一步！",
  成为客户: "成为客户",
  售后管理: "售后管理",
  问题反馈: "问题反馈",
  查询: "查询",
  输入运单号: "输入运单号",
  提交日期: "提交日期",
  问题描述: "问题描述",
  处理结果: "处理结果",
  请输入问题描述: "请输入问题描述",
  提交: "提交",
  查看问题: "查看问题",
  处理中: "处理中",
  已完结: "已完结",
  "Come on Join Us！": "Come on Join Us！",
  请支付: "请支付",
  请选择支付方式: "请选择支付方式",
  Pix支付: "Pix支付",
  信用卡: "信用卡",
  "剩余时间：x秒": "剩余时间：{count}秒", //
  使用扫码支付: "使用扫码支付",
  复制二维码code: "复制二维码code",
  完成支付: "完成支付",
  请填写支付信息: "请填写支付信息",
  卡号: "卡号",
  持卡人姓名: "持卡人姓名",
  CVV码: "CVV码",
  "有效期MM/YYYY": "有效期MM/YYYY",
  选择日期: "选择日期",
  完成付款: "完成付款",
  开始日期: "开始日期",
  结束日期: "结束日期",
  输入收件人姓名: "输入收件人姓名",
  支付状态: "支付状态",
  待支付: "待支付",
  已支付: "已支付",
  信用卡预授权成功: "信用卡预授权成功",
  信用卡授权成功: "信用卡授权成功",
  待客户寄件: "待客户寄件",
  附件下载: "附件下载",
  支付: "支付",
  取消订单: "取消订单",
  取消订单您需要知晓: "取消订单您需要知晓",
  "取消后，订单将无法寄出。": "取消后，订单将无法寄出。",
  使用Pix支付: "使用Pix支付",
  退款处理时间最长为7个工作日: "退款处理时间最长为7个工作日",
  退款账户必须与付款时使用的账户姓名一致: "退款账户必须与付款时使用的账户姓名一致",
  信用卡支付: "信用卡支付",
  将实时的取消授权支付: "将实时的取消授权支付",
  二维码已过期: "二维码已过期",
  复制成功: "复制成功",
  "支付失败，如您确认完成支付请重新点击完成支付，获取支付状态，如有疑问请联系：客服":
    "支付失败，如您确认完成支付请重新点击完成支付，获取支付状态，如有疑问请联系：客服",
  请输入卡号: "请输入卡号",
  请输入CVV码: "请输入CVV码",
  请选择日期: "请选择日期",
  输入需大于0: "输入需大于0",
  有效期至: "有效期至",
  快过期: "快过期",
  去使用: "去使用",
  我的优惠券: "我的优惠券",
  "还没有优惠券哦，快去领取吧～": "还没有优惠券哦，快去领取吧～",
  优惠信息: "优惠信息",
  优惠券编码: "优惠券编码",
  优惠券金额: "优惠券金额",
  具体费用以实际网点为准: "具体费用以实际网点为准",
  选择优惠券: "选择优惠券",
  活动描述: "活动描述",
  活动时间: "活动时间",
  立即领取: "立即领取",
  "领取成功！优惠券已存入您的账户，快去使用吧~": "领取成功！优惠券已存入您的账户，快去使用吧~",
  热门活动: "热门活动",
  打卡得: "打卡得",
  胡萝卜: "胡萝卜",
  "点击可喂食MaoMao～": "点击可喂食MaoMao～",
  去试试: "去试试",
  寄快递: "寄快递",
  批量寄: "批量寄",
  运单查询: "运单查询",
  我的资料: "我的资料",
  "MaoMao Pet": "MaoMao Pet",
  请输入优惠券名称: "请输入优惠券名称",
  优惠券已关联活动无法编辑或删除: "优惠券已关联活动无法编辑或删除",
  "是否确认修改?": "是否确认修改?",
  优惠券名称已存在: "优惠券名称已存在",
  请输入活动名称: "请输入活动名称",
  "请输入1~99的数值": "请输入1~99的数值",
  "最大数值为7位整数+2位小数,最小值为1": "最大数值为7位整数+2位小数,最小值为1",
  请选择优惠券: "请选择优惠券",
  领取数: "领取数",
  核销数: "核销数",
  未核销数: "未核销数",
  活动进行中或已结束不可删除: "活动进行中或已结束不可删除",
  活动进行中或已结束不可编辑: "活动进行中或已结束不可编辑",
  相关活动名称: "相关活动名称",
  待核销: "待核销",
  已核销: "已核销",
  优惠券使用明细导出: "优惠券使用明细导出",
  "暂无活动，尽情期待~": "暂无活动，尽情期待~",
  工作日: "工作日",
  休息日: "休息日",
  更多操作: "更多操作",
  注销账号: "注销账号",
  注销协议: "注销协议",
  重要提醒: "重要提醒",
  "您是否确定注销账号并同意放弃账号绑定的相关数据及资产？确定后您的账户会立即完成注销。":
    "您是否确定注销账号并同意放弃账号绑定的相关数据及资产？确定后您的账户会立即完成注销。",
  "我已阅读并同意《注销协议》": "我已阅读并同意《注销协议》",
  下一步: "下一步",
  是否确定注销账号: "是否确定注销账号",
  "您的账号在注销后将无法访问、无法恢复并永久关闭": "您的账号在注销后将无法访问、无法恢复并永久关闭",
  预制面单无法使用优惠券: "预制面单无法使用优惠券",
  预制面单号: "预制面单号",
  操作指引: "操作指引",
  "填写条形码下面的编号哦~": "填写条形码下面的编号哦~",
  活动即将开始: "活动即将开始",
  "J&T Express巴西公司保留本次活动的最终解释权。": "J&T Express巴西公司保留本次活动的最终解释权。",
  "详见《优惠券活动通用条款》。": "详见《优惠券活动通用条款》。",
  模版更新时间: "模版更新时间",
  订单: "订单",
  钱包: "钱包",
  充值: "充值",
  钱包流水: "钱包流水",
  科目: "科目",
  暂无交易记录: "暂无交易记录",
  金额设置: "金额设置",
  请输入充值金额: "请输入充值金额",
  支付方式: "支付方式",
  取消付款: "取消付款",
  "输入范围1~2000": "输入范围1~2000",
  钱包支付: "钱包支付",
  交易后金额: "交易后金额",
  全部: "全部",
  散单运单运费: "散单运单运费",
  运费补差价: "运费补差价",
  钱包充值: "钱包充值",
  退运费: "退运费",
  订单取消: "订单取消",
  电子钱包: "电子钱包",
  使用钱包支付: "使用钱包支付",
  当前余额: "当前余额",
  支付失败: "支付失败",
  "余额不足, 请尽快充值": "余额不足, 请尽快充值",
  我的钱包: "我的钱包",
  时间: "时间",
  交易金额: "交易金额",
  自定义金额: "自定义金额",
  控制您的隐私: "控制您的隐私",
  "我们的网站使用cookie来改善导航。": "我们使用 Cookie 优化性能并推荐相关内容，以提升您的浏览体验。",
  拒绝: "拒绝",
  接受: "接受",
  Cookie政策: "Cookie政策",
  运费差额补收: "运费差额补收",
  已支付金额: "已支付金额",
  实际称重: "实际称重",
  "余额不足，请尽快充值": "余额不足，请尽快充值",
  "运费未结清，请结清后下单。": "运费未结清，请结清后下单。",
  确认使用钱包余额进行支付: "确认使用钱包余额进行支付",
  公告: "公告",
  紧急公告: "紧急公告",
  上线公告: "上线公告",
  系统公告: "系统公告",
  置顶: "置顶",
  必读: "必读",
  发布时间: "发布时间",
  暂无公告: "暂无公告",
  "请输入 1~100 的正整数": "请输入 1~100 的正整数",
  "44位数字": "44位数字",
  最大3位数字: "最大3位数字",
  "最大9999999.99的数字": "最大9999999.99的数字",
  NCM编码: "NCM编码",
  物品单价: "物品单价",
  请输入物品单价: "请输入物品单价",
  物品数量: "物品数量",
  请输入物品数量: "请输入物品数量",
  物品总金额: "物品总金额",
  请输入物品总金额: "请输入物品总金额",
  "DC-e密钥": "DC-e密钥",
  "请输入DC-e密钥": "请输入DC-e密钥",
  序列号: "序列号",
  请输入序列号: "请输入序列号",
  金额: "金额",
  请输入金额: "请输入金额",
  授权日期: "授权日期",
  请选择授权日期: "请选择授权日期",
  "请选择DC-e": "请选择DC-e",
  获取失败: "获取失败",
  "获取DC-e": "获取DC-e",
  获取: "获取",
  请输入NCM编码进行搜索: "请输入NCM编码进行搜索",
  请输入NCM编码: "请输入NCM编码",
  物品总金额不能超过1000: "物品总金额不能超过1000",
  "DC-e 获取成功": "DC-e 获取成功",
  发票信息: "发票信息",
  待获取: "待获取",
  优惠券: "优惠券",
  请输入有效字符: "请输入有效字符",
  成为我们的加盟商: "成为我们的加盟商",
  成为我们的PUDO站点: "成为我们的PUDO站点",
  批量支付: "批量支付",
  云仓: "云仓",
  JoinUs: {
    合作机会: "合作机会",
    您的店铺可以成为: "您的店铺可以成为",
    极兔速递收集点: "极兔速递收集点",
    "并产生额外收入。": "并产生额外收入。",
    零加盟费: "零加盟费",
    零固定成本: "零固定成本",
    无需库存: "无需库存",
    我想成为极免速递收集点: "我想成为极免速递收集点",
    "提案提交成功！": "提案提交成功！",
    "我们已收到您成为极兔速递加盟商的意向。我们的销售团队将在48小时内与您联系，介绍完整的业务计划。":
      "我们已收到您成为极兔速递加盟商的意向。我们的销售团队将在48小时内与您联系，介绍完整的业务计划。",
    提交新提案: "提交新提案",
    "立即注册！": "立即注册！",
    "填写您的详细信息，成为极兔速递收集点。": "填写您的详细信息，成为极兔速递收集点。",
    姓名: "姓名",
    电子邮件: "电子邮件",
    电话: "电话",
    营业执照号: "营业执照号",
    地址: "地址",
    邮编: "邮编",
    城市: "城市",
    州: "州",
    "您是否已经为其他网络工作？": "您是否已经为其他网络工作？",
    是: "是",
    否: "否",
    提交注册: "提交注册",
    "标有 * 的字段为必填项": "标有 * 的字段为必填项",
    成功合作伙伴: "成功合作伙伴",
    评价: "评价",
    合作伙伴怎么说: "合作伙伴怎么说",
    极兔速递加盟商和合作伙伴的真实体验: "极兔速递加盟商和合作伙伴的真实体验",
    "为什么选择极兔？": "为什么选择极兔？",
    巴西最大的私营物流网络之一: "巴西最大的私营物流网络之一",
    "极免速递是巴西最大的私营物流网络之一,提供强大的基础设施来满足业多和消费者需求":
      "极免速递是巴西最大的私营物流网络之一,提供强大的基础设施来满足业多和消费者需求",
    主要电商平台的全球战略合作伙伴: "主要电商平台的全球战略合作伙伴",
    "极兔速递是主要电商平台的全球战略合作伙伴,如Shopee和Mercado Livre,提供对广泛市场的访问和客户。":
      "极兔速递是主要电商平台的全球战略合作伙伴,如Shopee和Mercado Livre,提供对广泛市场的访问和客户。",
    先进技术和持续培训推动您的业务: "先进技术和持续培训推动您的业务",
    "极兔速递投资于先进技术,并为合作伙伴提供持续培训,帮助优化运营并提高生产力。":
      "兔速递投资于先进技术,并为合作伙伴提供持续培训,帮助优化运营并提高生产力。",
    独家商业机会: "独家商业机会",
    成为: "成为",
    极兔速递: "极兔速递",
    加盟商: "加盟商",
    我想成为极免速递加盟商: "我想成为极免速递加盟商",
    "表达您的兴趣！": "表达您的兴趣！",
    "填写表格并获取有关加盟的详细信息。": "填写表格并获取有关加盟的详细信息。",
    提交提案: "提交提案",
    谁已经在极兔速递的推动下增长: "谁已经在极兔速递的推动下增长",
    "看看一些正在与我们共同构建历史的加盟商。": "看看一些正在与我们共同构建历史的加盟商。",
    我们的客户: "我们的客户",
    信任极兔速递进行物流运营的领先公司: "信任极兔速递进行物流运营的领先公司",
    我们的加盟商怎么说: "我们的加盟商怎么说",
    "为什么选择极兔速递？": "为什么选择极兔速递？",
    经过验证的商业模式: "经过验证的商业模式",
    "在数千次日常运营中测试和验证的运营系统,具有明确定义的流程和尖端技术。": "在数千次日常运营中测试和验证的运营系统,具有明确定义的流程和尖端技术。",
    独家和受保护的领地: "独家和受保护的领地",
    "通过区域独家权确保您的运营区域,在没有内部竞争的情况下最大化您的市场潜力。":
      "通过区域独家权确保您的运营区域,在没有内部竞争的情况下最大化您的市场潜力。",
    技术和持续创新: "技术和持续创新",
    "访问专有管理系统、实时跟踪和优化运营的工具。": "访问专有管理系统、实时跟踪和优化运营的工具。",
    "加入极兔革新您所在地区的物流格局。": "加入极兔,革新您所在地区的物流格局。",
    "先到者,得更多。": "先到者,得更多。",
    "注册已提交！": "注册已提交！",
    "我们已收到您的信息。我们的团队将很快与您联系，继续您作为极兔速递收集点的注册。":
      "我们已收到您的信息。我们的团队将很快与您联系，继续您作为极兔速递收集点的注册。",
    提交新注册: "提交新注册",
    Pudo1: {
      name: "Gabriela Bizio",
      location: "圣保罗",
      text: "自从我们合作开始以来,最让我印象深刻的是公司对效率的承诺以及对员工和合作伙伴的尊重。能够成为一个重视敏捷性而不影响质量的结构的一部分令人满意。",
    },
    Pudo2: {
      name: "Marcelo Vilalva",
      location: "大坎普",
      text: "今天,我们已经在评估扩大结构的可能性,以跟上不断增长的需求。这次经历向我们展示,与极兔速递的合作不仅加强了我们的业务,还为客户带来了直接的好处,他们现在在发送订单时享有更多的便利和效率。",
    },
    Pudo3: {
      name: "Almenildo Santos",
      location: "里约热内卢",
      text: "极兔速递是一个可靠的合作伙伴,我很自豪能成为一家在数字世界中增长和发展最快的快递公司团队的一员。极兔速递以透明度、快速响应和不断寻求改进为客户提供最佳服务而工作。",
    },
    Pudo4: {
      name: "Talita Previatti",
      location: "圣保罗",
      text: "我从2025年3月开始成为极兔速递收集点,我要说的是合作非常好。从我开始以来,流程一直非常简单易行,直到今天仍然如此,而且越来越好。",
    },
    Fran1: {
      name: "WERONICE",
      location: "伊瓜苏市",
      text: "如果你问我,我期望在不久的将来从这种伙伴关系中获得什么,我根本不会知道我们将从中获得的巨大利益。",
    },
    Fran2: {
      name: "Ricardo Alves",
      location: "坎皮纳斯",
      text: "运营结构完全提升了我们的配送标准。",
    },
    Fran3: {
      name: "Juliana Moraes",
      location: "贝洛奥里藏特",
      text: "战略支持在我们的增长中起到了决定性作用。",
    },
    Fran4: {
      name: "Marcos Vinícius",
      location: "库里蒂巴",
      text: "技术为我们的客户带来了更高的效率和信任。",
    },
    Fran5: {
      name: "Aline Souza",
      location: "累西腓",
      text: "这次合作为我们带来了稳定性和可持续的扩张。",
    },
    Fran6: {
      name: "Fernando Lima",
      location: "戈亚尼亚",
      text: "运营稳健,具有清晰的战略眼光,专注于增长。",
    },
  },
  fulfill: {
    以仓为核重构巴西物流布局: "以仓为核，重构巴西物流布局",
    通过分布式智能云仓网络我们建立了下一代供应链示范实现: "通过分布式智能云仓网络，我们建立了下一代供应链示范，实现：",
    商品前置化: "商品前置化",
    履约无缝化: "履约无缝化",
    响应敏捷化: "响应敏捷化",
    以仓库为中心我们重新设计了巴西的整个物流体系: "以仓库为中心，我们重新设计了巴西的整个物流体系",
    通过分布式智能云仓网络我们创建了下一代供应链模型实现了: "通过分布式智能云仓网络，我们创建了下一代供应链模型，实现了：",
    产品的提前布局: "产品的提前布局",
    订单无间断履行: "订单无间断履行",
    更快速高效的响应: "更快速、高效的响应",
    联系我们: "联系我们",
    填写表格并获取我们的仓储履约服务信息: "填写表格并获取我们的仓储履约服务信息",
    基础信息: "基础信息",
    公司名称必填: "* 公司名称",
    CNPJCPF必填: "* CNPJ / CPF",
    联系人必填: "* 联系人",
    电话必填: "* 电话",
    邮箱必填: "* 邮箱",
    业务规模: "业务规模",
    月订单量: "月订单量",
    SKU数量: "SKU数量",
    需要的服务可多选: "需要的服务（可多选）",
    仓储: "仓储",
    一件代发: "一件代发",
    退货处理: "退货处理",
    发送提案: "发送提案",
    请输入公司名称: "请输入公司名称",
    公司名称长度不能超过60字符: "公司名称长度不能超过60字符",
    请输入CNPJCPF: "请输入CNPJ/CPF",
    CNPJCPF格式不正确: "CNPJ/CPF格式不正确",
    请输入联系人: "请输入联系人",
    联系人长度不能超过50字符: "联系人长度不能超过50字符",
    请输入电话: "请输入电话",
    电话格式不正确: "电话格式不正确",
    请输入邮箱: "请输入邮箱",
    邮箱格式不正确: "邮箱格式不正确",
    标有星号的字段为必填项: "标有 * 的字段为必填项",
    了解更多: "了解更多",
    联系邮箱: "联系邮箱",
    自研仓储管理系统: "自研仓储管理系统",
    自研仓储管理系统描述1:
      "我们自研的仓储管理系统，根据客户属性、业务需求和具体场景，对仓储流程进行数字化监控，以实现仓储服务的精细化、智能化与可视化系统。",
    自研仓储管理系统描述2: "在此基础上，精准预估库存需求，提前安排补货，从而显著提高订单处理效率，同时有效规避缺货及库存积压问题。",
    运营优势: "运营优势",
    仓库网络: "仓库网络",
    仓库网络描述: "完善全球仓及末端网络布局，助力跨境卖家远帆出海，实现全球物流网络无缝对接",
    全国覆盖: "全国覆盖",
    区域物流中心: "区域物流中心",
    优化分发: "优化分发",
    自有终端: "自有终端",
    自有终端描述: "快递网络遍布13个国家，配送服务范围覆盖广",
    受控配送: "受控配送",
    实时跟踪: "实时跟踪",
    保证质量: "保证质量",
    集成存储和配送: "集成存储和配送",
    集成存储和配送描述: "仓储位于极兔物流中心园区，依托于快递分拨中心，可实现快递无缝揽收",
    集成流程: "集成流程",
    降低成本: "降低成本",
    更高效率: "更高效率",
    完整的产品解决方案: "完整的产品解决方案",
    完整的产品解决方案描述:
      "专注于B2B和B2C，仓储和配送作为核心。通过多样化的仓储和专业的最后一公里配送服务，它为跨境供应链提供完整解决方案（包括主干线运输、海关清关、存储、配送和退货服务）。",
    定制服务: "定制服务",
    运营灵活性: "运营灵活性",
    全面支持: "全面支持",
    多平台管理: "多平台管理",
    多平台管理描述: "支持多个商店多个国家和多个平台/商家仓库/线下超市和商店配送，执行统一的2B2C库存。",
    与Shopee和MercadoLivre等集成: "与Shopee、Mercado Livre等集成",
    统一库存可见性: "统一库存可见性",
    实时同步: "实时同步",
    运营质量: "运营质量",
    运营质量描述: "通过数字监控运营质量，我们提供全面、高效和高质量的服务。",
    进出检查: "进出检查",
    最低错误率: "最低错误率",
    详细质量报告: "详细质量报告",
    专业团队: "专业团队",
    专业团队描述: "专业支持团队、专有且完全管理的存储和配送系统，以及国外的本地管理团队，确保稳定运营。",
    认证专业人员: "认证专业人员",
    持续培训: "持续培训",
    客户专属支持: "客户专属支持",
    标准化服务: "标准化服务",
    标准化仓储和配送服务: "标准化仓储和配送服务",
    定制仓储服务: "定制仓储服务",
    增值服务: "增值服务",
    头程服务: "头程服务",
    国内揽收服务: "国内揽收服务",
    空海运头程: "空、海运头程",
    多式联运: "多式联运",
    仓内存储: "仓内存储",
    入口接收: "入口接收",
    库存管理: "库存管理",
    质量控制: "质量控制",
    交货时间监控: "交货时间监控",
    最终配送: "最终配送",
    订单生成: "订单生成",
    订单跟踪: "订单跟踪",
    负载生成: "负载生成",
    平台仓库: "平台仓库",
    电子商务平台集成: "电子商务平台集成",
    统一供应链管理: "统一供应链管理",
    类别仓库: "类别仓库",
    产品类型专业化: "产品类型专业化",
    类别优化管理: "类别优化管理",
    如服装鞋子电子产品美容产品等: "如服装、鞋子、电子产品、美容产品等",
    定制仓库: "定制仓库",
    基于客户需求的定制解决方案: "基于客户需求的定制解决方案",
    入库流程: "入库流程",
    质量检查: "质量检查",
    二次标签: "二次标签",
    外部分发: "外部分发",
    出库流程: "出库流程",
    集成包装: "集成包装",
    礼品包装: "礼品包装",
    包装定制: "包装定制",
    促销管理: "促销管理",
    售后和退货: "售后和退货",
    照片上传: "照片上传",
    退货检查: "退货检查",
    测试: "测试",
    回收: "回收",
    视觉报告: "视觉报告",
    名确认: "名确认",
    签名确认: "签名确认",
    报告审核: "报告审核",
    发货认证: "发货认证",
    配送跟踪: "配送跟踪",
    "加载失败，请刷新页面重试": "加载失败，请刷新页面重试",
  },
};
